export interface IAgentTypes {
    '@odata.context': string;
    Value: IAgentType[];
}

export interface IAgentType {
    Id: string;
    Created: Date;
    CreatedBy: string;
    LastModified: Date;
    LastModifiedBy: string;
    Description: string;
    DisplayName: string;
    DownloadLocation: string;
    IconUrl: string;
    Version: string;
}

export interface IAgentDetail {
    '@odata.type': string;
    Id: string;
    Created: Date;
    CreatedBy: string;
    LastModified: Date;
    LastModifiedBy: string;
    AgentName: string;
    AgentType: string;
    AttributeMap: string;
    ClientId: string;
    Configuration: string;
    DownloadLocation: string;
    EnforceMFA: boolean;
    IconUrl: string;
    OUs: string;
    OrganizationId: string;
    ProvisioningPolicyId: string;
    ProvisioningState: string;
    RawDirectoryPolicy: string;
    RawProtectedConfiguration: string;
    SelectedOUs: string;
    SendActivationEmail: boolean;
    StatusAction: string;
    SyncIntervalMinutes: number;
    WLA2FATimeoutSeconds: number;
    TenantId: string;
    Version: string;
    CustomClaimsMapping: string;
}

export interface IAgentClaims {
    '@odata.context': string;
    AgentProfileId: string;
    Configuration: string;
    Created: Date;
    CreatedBy: string;
    Id: string;
    IdentityId: string;
    LastModified: Date;
    LastModifiedBy: string;
}

export interface IAgentClientDetails {
    ClientId: string;
    ClientSecretValue: string;
    Roles: IClientRoles[];
}

export interface IClientRoles {
    Id: string;
    OrganizationId: string;
    Name: string;
    Permissions: string;
}

// What fields should be displayed for the config type
export interface IAgentConfigDisplay {
    ProvisionState: true;
    AgentName: true;
    IconUrl: true;
    RedirectURI: boolean;
    RequiresConsent: boolean;
    AgentType: boolean;
    SyncIntervalMinutes: boolean;
    PolicyId: boolean;
    WLA2FATimeoutSeconds: boolean;
}

export interface IPostAgentConfig {
    SyncIntervalMinutes: string;
    WLA2FATimeoutSeconds: string;
    IconUrl: string;
    AgentName: string;
    '@odata.type': 'Kaseya.AuthAnvil.Models.AgentProfile';
    OrganizationId: string;
    ClientId: string;
    AgentType: string;
    Version: '1.0';
    DownloadLocation: string;
    Configuration: any;
    ProvisioningState: string;
    PolicyId?: string;
    RequiresConsent?: boolean;
    RedirectUri?: string;
    RawProtectedConfiguration?: any;
    Type?: string;
    Id?: string;
    [propName: string]: any;
}

export interface IWebDefaultConfiguration {
    config_type: string;
    PolicyId: string;
    RequiresConsent: boolean;
}

export enum AgentTypeEnum {
    // Front end displayed value
    radiusServerDisplay = 'RADIUS Server',
    // backend value
    radiusServer = 'RADIUS',
    windowsLogon = 'Windows Logon',
    oauth2Client = 'OAuth2 Client',
    openidConnect = 'OpenID Connect',

    // This is the backend used value
    apiAuth = 'API Auth',
    // This is the frontend displayed value
    authApiDisplay = 'Auth API',

    // This is the backend used value
    webAuth = 'Web Auth',
    // This is the frontend displayed value
    embeddedWebAuthDisplay = 'Embedded Web Auth'
}

export enum PwSSyncAgentInstallTypeEnum {
    activeDirectoryDomain = 'ActiveDirectoryDomain',
    windowsLocal = 'WindowsLocal',
    thirdParty = 'ThirdParty'
}

export enum ClientIdPrefixEnum {
    radius = 'radius',
    cp = 'cp',
    oauth2 = 'oauth2',
    api = 'api',
    web = 'web',
    oidc = 'oidc'
}

export enum AgentConfigTypeEnum {
    webConfig = 'web_config',
    radiusConfig = 'radius_config',
    windowsLogonConfig = 'windowslogon_config'
}

export interface IClientPermissionDialogData {
    checked: boolean;
    odataType: string;
    name: string;
    id: string;
    permissions: string;
    organizationId: string;
    tenantId: string;
}

export interface IRadiusClient {
    name: string;
    ip: string;
    password: string;
    policy: { label: string; value: string; };
    features: RadiusClientFeature;
}

export interface IWindowsLogonConfig {
    LogonWithPush: boolean;
    RDPOnly2FA: boolean;
    HasOverrideGroup: boolean;
    OverrideGroupRequires2FA: boolean;
    HasOverridePassword: boolean;
    HideRemoteSessions: boolean;
    AllowOfflineAccess: boolean;
    AllowOfflineAccessForXDays: number;
    OrgMappings: IOrgMapping[];
    HasAliasRedirect: boolean;
    [propName: string]: any;
}

export interface IOrgMapping {
    Domain: string;
    AliasFor: string;
    homeRealm: string;
    client_id: string;
    client_secret: string;
    [propName: string]: any;
}

export enum RadiusClientFeature {
    None = 0,
    RequireMessageAuthenticator = 1
}